"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamsLookupServiceServer = exports.TeamsLookupServiceDispatcher = exports.TeamsLookupServiceClient = void 0;
var octopus_common_1 = require("@playq/octopus-common");
var services_teams_1 = require("@playq/services-teams");
var GetTemplatesResult_1 = require("./GetTemplatesResult");
var services_shared_1 = require("@playq/services-shared");
var services_common_data_1 = require("@playq/services-common-data");
var irt_1 = require("@playq/irt");
var InGetTemplate = (function () {
    function InGetTemplate(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.templateId = new services_shared_1.TeamTemplateId(data.templateId);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InGetTemplate.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InGetTemplate.prototype, "templateId", {
        get: function () {
            return this._templateId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field templateId is not optional');
            }
            this._templateId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InGetTemplate.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InGetTemplate.prototype.serialize = function () {
        return {
            appID: this.appID.serialize(),
            templateId: this.templateId.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InGetTemplate;
}());
var OutGetTemplateHelpers = (function () {
    function OutGetTemplateHelpers() {
    }
    OutGetTemplateHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutGetTemplateHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_teams_1.TeamTemplate(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutGetTemplateHelpers;
}());
var InGetTemplates = (function () {
    function InGetTemplates(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.offsetLimit = new services_shared_1.OffsetLimit(data.offsetLimit);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InGetTemplates.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InGetTemplates.prototype, "offsetLimit", {
        get: function () {
            return this._offsetLimit;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field offsetLimit is not optional');
            }
            this._offsetLimit = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InGetTemplates.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InGetTemplates.prototype.serialize = function () {
        return {
            appID: this.appID.serialize(),
            offsetLimit: this.offsetLimit.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InGetTemplates;
}());
var OutGetTemplatesHelpers = (function () {
    function OutGetTemplatesHelpers() {
    }
    OutGetTemplatesHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutGetTemplatesHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new GetTemplatesResult_1.GetTemplatesResult(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutGetTemplatesHelpers;
}());
var InSearchTeam = (function () {
    function InSearchTeam(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.templateId = new services_shared_1.TeamTemplateId(data.templateId);
        this.offsetLimit = new services_shared_1.OffsetLimit(data.offsetLimit);
        this.filter = typeof data.filter !== 'undefined' ? new services_teams_1.TeamFilter(data.filter) : undefined;
        this.search = typeof data.search !== 'undefined' ? new services_teams_1.TeamSearch(data.search) : undefined;
        this.sort = typeof data.sort !== 'undefined' ? new services_teams_1.TeamSort(data.sort) : undefined;
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InSearchTeam.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InSearchTeam.prototype, "templateId", {
        get: function () {
            return this._templateId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field templateId is not optional');
            }
            this._templateId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InSearchTeam.prototype, "offsetLimit", {
        get: function () {
            return this._offsetLimit;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field offsetLimit is not optional');
            }
            this._offsetLimit = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InSearchTeam.prototype, "filter", {
        get: function () {
            return this._filter;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._filter = undefined;
                return;
            }
            this._filter = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InSearchTeam.prototype, "search", {
        get: function () {
            return this._search;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._search = undefined;
                return;
            }
            this._search = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InSearchTeam.prototype, "sort", {
        get: function () {
            return this._sort;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._sort = undefined;
                return;
            }
            this._sort = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InSearchTeam.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InSearchTeam.prototype.serialize = function () {
        return {
            appID: this.appID.serialize(),
            templateId: this.templateId.serialize(),
            offsetLimit: this.offsetLimit.serialize(),
            filter: typeof this.filter !== 'undefined' ? this.filter.serialize() : undefined,
            search: typeof this.search !== 'undefined' ? this.search.serialize() : undefined,
            sort: typeof this.sort !== 'undefined' ? this.sort.serialize() : undefined,
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InSearchTeam;
}());
var OutSearchTeamHelpers = (function () {
    function OutSearchTeamHelpers() {
    }
    OutSearchTeamHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutSearchTeamHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_teams_1.TeamFetchResult(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutSearchTeamHelpers;
}());
var InUpdateTeam = (function () {
    function InUpdateTeam(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.teamId = new services_teams_1.TeamIdWithTemplateId(data.teamId);
        this.teamParameters = services_teams_1.TeamParametersStruct.create(data.teamParameters);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InUpdateTeam.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateTeam.prototype, "teamId", {
        get: function () {
            return this._teamId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field teamId is not optional');
            }
            this._teamId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateTeam.prototype, "teamParameters", {
        get: function () {
            return this._teamParameters;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field teamParameters is not optional');
            }
            this._teamParameters = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateTeam.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpdateTeam.prototype.serialize = function () {
        var _a;
        return {
            appID: this.appID.serialize(),
            teamId: this.teamId.serialize(),
            teamParameters: (_a = {}, _a[this.teamParameters.getFullClassName()] = this.teamParameters.serialize(), _a),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InUpdateTeam;
}());
var OutUpdateTeamHelpers = (function () {
    function OutUpdateTeamHelpers() {
    }
    OutUpdateTeamHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUpdateTeamHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUpdateTeamHelpers;
}());
var InGetTeam = (function () {
    function InGetTeam(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.teamId = new services_teams_1.TeamIdWithTemplateId(data.teamId);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InGetTeam.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InGetTeam.prototype, "teamId", {
        get: function () {
            return this._teamId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field teamId is not optional');
            }
            this._teamId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InGetTeam.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InGetTeam.prototype.serialize = function () {
        return {
            appID: this.appID.serialize(),
            teamId: this.teamId.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InGetTeam;
}());
var OutGetTeamHelpers = (function () {
    function OutGetTeamHelpers() {
    }
    OutGetTeamHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutGetTeamHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_teams_1.TeamLookup(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutGetTeamHelpers;
}());
var InUpdateMemberVault = (function () {
    function InUpdateMemberVault(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.teamId = new services_teams_1.TeamIdWithTemplateId(data.teamId);
        this.userId = new services_shared_1.UserId(data.userId);
        this.update = new services_common_data_1.DataValuesPartialUpdate(data.update);
        this.expectedVersion = data.expectedVersion;
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InUpdateMemberVault.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateMemberVault.prototype, "teamId", {
        get: function () {
            return this._teamId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field teamId is not optional');
            }
            this._teamId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateMemberVault.prototype, "userId", {
        get: function () {
            return this._userId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field userId is not optional');
            }
            this._userId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateMemberVault.prototype, "update", {
        get: function () {
            return this._update;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field update is not optional');
            }
            this._update = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateMemberVault.prototype, "expectedVersion", {
        get: function () {
            return this._expectedVersion;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field expectedVersion is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field expectedVersion expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field expectedVersion is expected to be an integer, got ' + value);
            }
            if (value < 0) {
                throw new Error('Field expectedVersion is expected to be not less than 0, got ' + value);
            }
            if (value > 18446744073709551615) {
                throw new Error('Field expectedVersion is expected to be not greater than 18446744073709551615, got ' + value);
            }
            this._expectedVersion = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateMemberVault.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpdateMemberVault.prototype.serialize = function () {
        return {
            appID: this.appID.serialize(),
            teamId: this.teamId.serialize(),
            userId: this.userId.serialize(),
            update: this.update.serialize(),
            expectedVersion: this.expectedVersion,
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InUpdateMemberVault;
}());
var OutUpdateMemberVaultHelpers = (function () {
    function OutUpdateMemberVaultHelpers() {
    }
    OutUpdateMemberVaultHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUpdateMemberVaultHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_teams_1.TeamMemberVault(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUpdateMemberVaultHelpers;
}());
var InKickMember = (function () {
    function InKickMember(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.teamId = new services_teams_1.TeamIdWithTemplateId(data.teamId);
        this.userId = new services_shared_1.UserId(data.userId);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InKickMember.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InKickMember.prototype, "teamId", {
        get: function () {
            return this._teamId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field teamId is not optional');
            }
            this._teamId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InKickMember.prototype, "userId", {
        get: function () {
            return this._userId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field userId is not optional');
            }
            this._userId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InKickMember.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InKickMember.prototype.serialize = function () {
        return {
            appID: this.appID.serialize(),
            teamId: this.teamId.serialize(),
            userId: this.userId.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InKickMember;
}());
var OutKickMemberHelpers = (function () {
    function OutKickMemberHelpers() {
    }
    OutKickMemberHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutKickMemberHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutKickMemberHelpers;
}());
var InPromoteMember = (function () {
    function InPromoteMember(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.teamId = new services_teams_1.TeamIdWithTemplateId(data.teamId);
        this.userId = new services_shared_1.UserId(data.userId);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InPromoteMember.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InPromoteMember.prototype, "teamId", {
        get: function () {
            return this._teamId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field teamId is not optional');
            }
            this._teamId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InPromoteMember.prototype, "userId", {
        get: function () {
            return this._userId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field userId is not optional');
            }
            this._userId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InPromoteMember.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InPromoteMember.prototype.serialize = function () {
        return {
            appID: this.appID.serialize(),
            teamId: this.teamId.serialize(),
            userId: this.userId.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InPromoteMember;
}());
var OutPromoteMemberHelpers = (function () {
    function OutPromoteMemberHelpers() {
    }
    OutPromoteMemberHelpers.serialize = function (either) {
        var _a;
        return either.isRight() ? {
            'Success': (_a = {}, _a[either.value.getFullClassName()] = either.value.serialize(), _a)
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutPromoteMemberHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(services_teams_1.TeamMemberDataStruct.create(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutPromoteMemberHelpers;
}());
var InDemoteMember = (function () {
    function InDemoteMember(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appID = new octopus_common_1.AppID(data.appID);
        this.teamId = new services_teams_1.TeamIdWithTemplateId(data.teamId);
        this.userId = new services_shared_1.UserId(data.userId);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InDemoteMember.prototype, "appID", {
        get: function () {
            return this._appID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appID is not optional');
            }
            this._appID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDemoteMember.prototype, "teamId", {
        get: function () {
            return this._teamId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field teamId is not optional');
            }
            this._teamId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDemoteMember.prototype, "userId", {
        get: function () {
            return this._userId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field userId is not optional');
            }
            this._userId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDemoteMember.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InDemoteMember.prototype.serialize = function () {
        return {
            appID: this.appID.serialize(),
            teamId: this.teamId.serialize(),
            userId: this.userId.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InDemoteMember;
}());
var OutDemoteMemberHelpers = (function () {
    function OutDemoteMemberHelpers() {
    }
    OutDemoteMemberHelpers.serialize = function (either) {
        var _a;
        return either.isRight() ? {
            'Success': (_a = {}, _a[either.value.getFullClassName()] = either.value.serialize(), _a)
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDemoteMemberHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(services_teams_1.TeamMemberDataStruct.create(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDemoteMemberHelpers;
}());
var TeamsLookupServiceClient = (function () {
    function TeamsLookupServiceClient(transport) {
        this._transport = transport;
    }
    TeamsLookupServiceClient.prototype.getPackageName = function () { return TeamsLookupServiceClient.PackageName; };
    TeamsLookupServiceClient.prototype.getClassName = function () { return TeamsLookupServiceClient.ClassName; };
    TeamsLookupServiceClient.prototype.getFullClassName = function () { return TeamsLookupServiceClient.FullClassName; };
    TeamsLookupServiceClient.prototype.send = function (method, data, inputType, outputType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._transport.send(TeamsLookupServiceClient.ClassName, method, data)
                .then(function (data) {
                try {
                    var output = new outputType(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    TeamsLookupServiceClient.prototype.getTemplate = function (appID, templateId, env) {
        var _this = this;
        var __data = new InGetTemplate();
        __data.appID = appID;
        __data.templateId = templateId;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(TeamsLookupServiceClient.ClassName, 'getTemplate', __data)
                .then(function (data) {
                try {
                    resolve(OutGetTemplateHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    TeamsLookupServiceClient.prototype.getTemplates = function (appID, offsetLimit, env) {
        var _this = this;
        var __data = new InGetTemplates();
        __data.appID = appID;
        __data.offsetLimit = offsetLimit;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(TeamsLookupServiceClient.ClassName, 'getTemplates', __data)
                .then(function (data) {
                try {
                    resolve(OutGetTemplatesHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    TeamsLookupServiceClient.prototype.searchTeam = function (appID, templateId, offsetLimit, filter, search, sort, env) {
        var _this = this;
        var __data = new InSearchTeam();
        __data.appID = appID;
        __data.templateId = templateId;
        __data.offsetLimit = offsetLimit;
        __data.filter = filter;
        __data.search = search;
        __data.sort = sort;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(TeamsLookupServiceClient.ClassName, 'searchTeam', __data)
                .then(function (data) {
                try {
                    resolve(OutSearchTeamHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    TeamsLookupServiceClient.prototype.updateTeam = function (appID, teamId, teamParameters, env) {
        var _this = this;
        var __data = new InUpdateTeam();
        __data.appID = appID;
        __data.teamId = teamId;
        __data.teamParameters = teamParameters;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(TeamsLookupServiceClient.ClassName, 'updateTeam', __data)
                .then(function (data) {
                try {
                    resolve(OutUpdateTeamHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    TeamsLookupServiceClient.prototype.getTeam = function (appID, teamId, env) {
        var _this = this;
        var __data = new InGetTeam();
        __data.appID = appID;
        __data.teamId = teamId;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(TeamsLookupServiceClient.ClassName, 'getTeam', __data)
                .then(function (data) {
                try {
                    resolve(OutGetTeamHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    TeamsLookupServiceClient.prototype.updateMemberVault = function (appID, teamId, userId, update, expectedVersion, env) {
        var _this = this;
        var __data = new InUpdateMemberVault();
        __data.appID = appID;
        __data.teamId = teamId;
        __data.userId = userId;
        __data.update = update;
        __data.expectedVersion = expectedVersion;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(TeamsLookupServiceClient.ClassName, 'updateMemberVault', __data)
                .then(function (data) {
                try {
                    resolve(OutUpdateMemberVaultHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    TeamsLookupServiceClient.prototype.kickMember = function (appID, teamId, userId, env) {
        var _this = this;
        var __data = new InKickMember();
        __data.appID = appID;
        __data.teamId = teamId;
        __data.userId = userId;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(TeamsLookupServiceClient.ClassName, 'kickMember', __data)
                .then(function (data) {
                try {
                    resolve(OutKickMemberHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    TeamsLookupServiceClient.prototype.promoteMember = function (appID, teamId, userId, env) {
        var _this = this;
        var __data = new InPromoteMember();
        __data.appID = appID;
        __data.teamId = teamId;
        __data.userId = userId;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(TeamsLookupServiceClient.ClassName, 'promoteMember', __data)
                .then(function (data) {
                try {
                    resolve(OutPromoteMemberHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    TeamsLookupServiceClient.prototype.demoteMember = function (appID, teamId, userId, env) {
        var _this = this;
        var __data = new InDemoteMember();
        __data.appID = appID;
        __data.teamId = teamId;
        __data.userId = userId;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(TeamsLookupServiceClient.ClassName, 'demoteMember', __data)
                .then(function (data) {
                try {
                    resolve(OutDemoteMemberHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    TeamsLookupServiceClient.PackageName = 'net.playq.octopus2.tgservices';
    TeamsLookupServiceClient.ClassName = 'TeamsLookupService';
    TeamsLookupServiceClient.FullClassName = 'net.playq.octopus2.tgservices.TeamsLookupService';
    return TeamsLookupServiceClient;
}());
exports.TeamsLookupServiceClient = TeamsLookupServiceClient;
var TeamsLookupServiceDispatcher = (function () {
    function TeamsLookupServiceDispatcher(marshaller, server) {
        this.marshaller = marshaller;
        this.server = server;
    }
    TeamsLookupServiceDispatcher.prototype.getSupportedService = function () {
        return 'TeamsLookupService';
    };
    TeamsLookupServiceDispatcher.prototype.getSupportedMethods = function () {
        return TeamsLookupServiceDispatcher.methods;
    };
    TeamsLookupServiceDispatcher.prototype.dispatch = function (context, method, data) {
        var _this = this;
        switch (method) {
            case "getTemplate": {
                var obj_1 = new InGetTemplate(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.getTemplate(context, obj_1.appID, obj_1.templateId, obj_1.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutGetTemplateHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "getTemplates": {
                var obj_2 = new InGetTemplates(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.getTemplates(context, obj_2.appID, obj_2.offsetLimit, obj_2.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutGetTemplatesHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "searchTeam": {
                var obj_3 = new InSearchTeam(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.searchTeam(context, obj_3.appID, obj_3.templateId, obj_3.offsetLimit, obj_3.filter, obj_3.search, obj_3.sort, obj_3.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutSearchTeamHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "updateTeam": {
                var obj_4 = new InUpdateTeam(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.updateTeam(context, obj_4.appID, obj_4.teamId, obj_4.teamParameters, obj_4.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpdateTeamHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "getTeam": {
                var obj_5 = new InGetTeam(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.getTeam(context, obj_5.appID, obj_5.teamId, obj_5.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutGetTeamHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "updateMemberVault": {
                var obj_6 = new InUpdateMemberVault(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.updateMemberVault(context, obj_6.appID, obj_6.teamId, obj_6.userId, obj_6.update, obj_6.expectedVersion, obj_6.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpdateMemberVaultHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "kickMember": {
                var obj_7 = new InKickMember(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.kickMember(context, obj_7.appID, obj_7.teamId, obj_7.userId, obj_7.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutKickMemberHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "promoteMember": {
                var obj_8 = new InPromoteMember(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.promoteMember(context, obj_8.appID, obj_8.teamId, obj_8.userId, obj_8.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutPromoteMemberHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "demoteMember": {
                var obj_9 = new InDemoteMember(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.demoteMember(context, obj_9.appID, obj_9.teamId, obj_9.userId, obj_9.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDemoteMemberHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            default:
                throw new Error("Method ".concat(method, " is not supported by TeamsLookupServiceDispatcher."));
        }
    };
    TeamsLookupServiceDispatcher.methods = [
        "getTemplate",
        "getTemplates",
        "searchTeam",
        "updateTeam",
        "getTeam",
        "updateMemberVault",
        "kickMember",
        "promoteMember",
        "demoteMember"
    ];
    return TeamsLookupServiceDispatcher;
}());
exports.TeamsLookupServiceDispatcher = TeamsLookupServiceDispatcher;
var TeamsLookupServiceServer = (function (_super) {
    __extends(TeamsLookupServiceServer, _super);
    function TeamsLookupServiceServer(marshaller) {
        var _this = _super.call(this, marshaller, null) || this;
        _this.server = _this;
        return _this;
    }
    TeamsLookupServiceServer.prototype.getTemplate = function (context, appID, templateId, env) {
        throw new Error('Not implemented.');
    };
    TeamsLookupServiceServer.prototype.getTemplates = function (context, appID, offsetLimit, env) {
        throw new Error('Not implemented.');
    };
    TeamsLookupServiceServer.prototype.searchTeam = function (context, appID, templateId, offsetLimit, filter, search, sort, env) {
        throw new Error('Not implemented.');
    };
    TeamsLookupServiceServer.prototype.updateTeam = function (context, appID, teamId, teamParameters, env) {
        throw new Error('Not implemented.');
    };
    TeamsLookupServiceServer.prototype.getTeam = function (context, appID, teamId, env) {
        throw new Error('Not implemented.');
    };
    TeamsLookupServiceServer.prototype.updateMemberVault = function (context, appID, teamId, userId, update, expectedVersion, env) {
        throw new Error('Not implemented.');
    };
    TeamsLookupServiceServer.prototype.kickMember = function (context, appID, teamId, userId, env) {
        throw new Error('Not implemented.');
    };
    TeamsLookupServiceServer.prototype.promoteMember = function (context, appID, teamId, userId, env) {
        throw new Error('Not implemented.');
    };
    TeamsLookupServiceServer.prototype.demoteMember = function (context, appID, teamId, userId, env) {
        throw new Error('Not implemented.');
    };
    return TeamsLookupServiceServer;
}(TeamsLookupServiceDispatcher));
exports.TeamsLookupServiceServer = TeamsLookupServiceServer;
//# sourceMappingURL=TeamsLookupService.js.map